/**
 * ILP status labels, built from tblStatus ids: 1 Saved, 2 Submitted, 3 Approved, 4 Rejected.
 *
 * The ILP screen and the timeline card both use this. The API's ILP read returns StatusId but no
 * StatusDescription, so the label has to come from the id.
 */

/** The status id to show. A row with no id falls back on its approved flag: Approved, otherwise Saved. */
export function ilpStatusId(statusId: number | null | undefined, approved: boolean | null | undefined): number {
  return statusId ?? (approved ? 3 : 1);
}

/**
 * The label for an ILP's status. State 1 is "Draft" on the ILP screen and "Saved" on the timeline card.
 * The status pill treats both names the same, so the caller picks which one it shows.
 */
export function ilpStatusLabel(statusId: number | null | undefined, approved: boolean | null | undefined,
  savedLabel: 'Draft' | 'Saved' = 'Draft'): string {
  switch (ilpStatusId(statusId, approved)) {
    case 1: return savedLabel;
    case 2: return 'Submitted';
    case 3: return 'Approved';
    case 4: return 'Rejected';
    default: return '';
  }
}
